import axios from 'axios';
import HllUI from 'hll-m-ui';
import qs from 'qs';
import { API_HOST } from '../config/host';
import { createSu } from '@hll/driver-js-utils';
import { getAllUrlParams } from '@/tools/other';
import Cookie from 'js-cookie';
import { isInEnterpriseApp } from '@/tools/app';
/**
 * 创建axios实例
 *
 * config.showLoading 请求时显示 Loading, 默认不显示
 * config.showError 请求报错时显示错误信息，默认显示
 */
const instance = axios.create({
  baseURL: `${API_HOST}/index.php`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  transformRequest: [
    function (data, headers) {
      if (!data) {
        return;
      }
      if (headers['Content-Type'] == 'multipart/form-data') {
        return data;
      }
      return qs.stringify(data);
    },
  ],
});
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    const params = getAllUrlParams();
    const commonParams = {
      original_from: params.original_from || undefined,
      device_id: params.device_id || undefined,
      _su: createSu(),
    };
    const passport_session_id = Cookie.get('passport_session_id');
    if (passport_session_id) {
      commonParams.passport_session_id = passport_session_id;
    } else {
      commonParams.token = params.token || params._token;
    }

    console.log(
      params.original_from,
      isInEnterpriseApp,
      params.token,
      params._token,
    );

    /*
      企业的客户端内拿不到url里的token，暂时只能通过UA获取token
      original_from=5表示企业，isInEnterpriseApp用于判断是否在企业客户端内
      企业H5的登录目前采用passport，此种方式传入的是passport_session_id，如果存在此passport id，则后端优先使用passport的id，如果没有才会考虑取token的情况
    */
    if (
      params.original_from === '5' &&
      isInEnterpriseApp &&
      params.token === undefined &&
      params._token === undefined // 兼容以后企业客户端接入了token的情况，如果url带了token，就不再使用此逻辑
    ) {
      const ua = navigator.userAgent;
      const res = ua.match(/com\.xiaolachuxing/);
      const arr = res[1].split(',');
      commonParams.token = arr[6];
      console.log(commonParams.token);
    }

    if (config.method === 'post') {
      config.data = {
        ...config.data,
        ...commonParams,
      };
    } else {
      config.params = {
        ...config.params,
        ...commonParams,
      };
    }

    if (!config.hideLoading) {
      HllUI.$hll.showLoading({
        cover: 2,
        delay: 500,
      });
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    HllUI.$hll.hideLoading();

    // h5定制性太强在业务里自己处理登录过期
    return response && response.data;
  },
  (error) => {
    HllUI.$hll.hideLoading();
    const config = (error.response || {}).config || {};
    if (config.showError !== false) {
      HllUI.$hll.toast(error.message || '系统错误');
    }
    return Promise.reject(error);
  },
);

export default instance;
